// CalendarEventSource — Primitive 2.
// The interface for materialising calendar events from any time-bound entity.
// Every "thing that happens at a time" registers a source; the unified
// calendar shows them all. See DOCS/architecture/primitives/calendar-event-source.md.
import { z } from 'zod';
// ---------------------------------------------------------------------------
// CalendarEvent — the row shape rendered on the calendar.
// ---------------------------------------------------------------------------
export const CalendarEventStatus = z.enum(['scheduled', 'live', 'past', 'cancelled']);
export const CalendarEvent = z.object({
    id: z.string().uuid(),
    /** Polymorphic subject — matches a LinkableKind kind. */
    subjectKind: z.string().min(1),
    subjectId: z.string().min(1),
    title: z.string(),
    /** ISO 8601 UTC. Always store UTC; render in viewer's TZ. */
    startsAt: z.string().datetime({ offset: true }),
    /** Null when point-in-time. */
    endsAt: z.string().datetime({ offset: true }).nullable(),
    /** TZ-neutral by spec when true. */
    allDay: z.boolean(),
    /** RFC 5545 RRULE expression; null = single occurrence. */
    recurrence: z.string().nullable(),
    /** Originating timezone (e.g. "America/Los_Angeles"). */
    tzid: z.string(),
    /** Visibility — mirrors source's groupIds. */
    groupIds: z.array(z.string()),
    status: CalendarEventStatus,
    createdBy: z.string().uuid(),
    schemaVersion: z.literal(1),
});
// ---------------------------------------------------------------------------
// Apply set — what `onSourceChange` returns.
// ---------------------------------------------------------------------------
export const CalendarEventApply = z.object({
    upsert: z.array(CalendarEvent),
    cancel: z.array(z.string().uuid()),
});
//# sourceMappingURL=calendar-event-source.js.map